import { ANALYTICS_CATEGORY_VIP_LANDING } from '@/constants/analytics'
import analytics from '@/shared-utils/analytics'

export function gaFAQ() {
  analytics.fireEvent({
    action: 'vip faq',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: 'faq click'
  })
}

export function gaBenefits(
  _action: string,
  _swipeDirection: string,
  activeTab: string
) {
  analytics.fireEvent({
    action: 'vip benefits grid',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: `${activeTab} tab`
  })
}

export function redirectToAuthPage({
  isPageInAppView
}: {
  isPageInAppView: boolean
}) {
  if (isPageInAppView) {
    window.location.href = '/next-profile/login?return-url=/vip'
  } else {
    window.location.href = '/home/join?flow=register&redirecturl=/vip'
  }
}

export function gaZigZag(id: number) {
  analytics.fireEvent({
    action: 'vip faq',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: `zig zag ${id} button`
  })
}

export function gaVipButton() {
  analytics.fireEvent({
    action: 'vip family promo',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: `create vip family`
  })
  window.location.href =
    '/home/join/?flow=authenticate&redirecturl=/next-profile/profile?tab=vip_family'
}
